import http from "./http";

//上传文件
export const uploadFile = async (data) => {
    return await http.post(`/webRequest/uploadFile`, data, {
        headers: { "Content-type": "multipart/form-data" },
    });
};
